(function($, undefined) {
	'use strict';
	let utils;
	let locationOverviewUtils;
	let confirmDeleteBtn;
	let cancelDeleteBtn;
	let deletePopupBtn;

	const init = () => {
		utils = Fw.component.models().utils;
		locationOverviewUtils = Fw.component.models().locationOverviewUtils;
		confirmDeleteBtn = $('.confirm-delete');
		cancelDeleteBtn = $('.popup-cancel');
		deletePopupBtn =  $('.delete-popup-btn');

		cancelDeleteBtn.on('click', ({currentTarget}) => {
			$(currentTarget).closest('.stool-shared-popup').removeClass('visible');
		});
		
		confirmDeleteBtn.on('click', (e) => {
			if(!e.currentTarget.className.includes('confirm-delete-pdf')) {
				const { itemId, type, noReload, saveLocation } = e.currentTarget.dataset;
				const popup = $(e.currentTarget).closest('.stool-shared-popup');
				const deletePopupInput = popup.find('.delete-popup-input');
				confirmDeleteBtn.addClass('btn-processing_active');
				cancelDeleteBtn.css('display','none');

				if (deletePopupInput.val().toLowerCase() === 'yes') {
					utils.deleteItemByType(itemId, type, () => {
						if(saveLocation === 'true') {
							$('.location-form-content__btns-section button').trigger('click');
						}
						if (noReload == "true") {
							cancelDeleteBtn.trigger("click");
							confirmDeleteBtn.removeClass('btn-processing_active');
							cancelDeleteBtn.css('display', 'block');
							deletePopupInput.val("");
							
							if (type == "location-overview") {
								locationOverviewUtils.reOrderItems();
							} else if (type == "location-site-plan" || type == "location-document") {
								$('.submit-location-document-form, .submit-location-site-plan-form').click();
							}
						}
						else {
							if (confirmDeleteBtn.attr("data-page-redirect")) {
								window.location.href = confirmDeleteBtn.attr("data-page-redirect");
							}
							else {							
								window.location.reload(true);
							}
						}
					}, Object.assign({}, e.currentTarget.dataset));
				} else {
					deletePopupInput.addClass('error');
					confirmDeleteBtn.removeClass('btn-processing_active');
					cancelDeleteBtn.css('display', 'block');
				}
			}
		});

		deletePopupBtn.on('click', ({currentTarget}) => {
			const { id } = currentTarget.dataset;
			var popupConfirmBtn = $(`.stool-shared-popup[data-id="${id}"] .confirm-delete`);
			
			if (popupConfirmBtn && popupConfirmBtn.length){
				Object.assign(popupConfirmBtn[0].dataset, currentTarget.dataset);
			}
		});
	};
  
	$(window).ready(function() {
	  	init();
	});
})(jQuery);
  